/* eslint-disable unicorn/no-empty-file */
// eslint-disable-next-line no-extend-native
Array.prototype.at ??= function at<T>(this: T[], idx: number) {
  return idx < 0 ? this[this.length + idx] : this[idx];
};
